import React from "react";
import { makeStyles } from "@mui/styles";
import { motion } from "framer-motion";
import { Grid } from "@mui/material";

export const Button = (props) => {

    const { title, action, type, directionX, directionY, breakPoints: [xs, sm, md, lg] } = props;
    const classes = useStyles();

    return (
        <Grid container justifyContent={ directionX } alignItems={ directionY }>
            <Grid item xs={ xs } sm={ sm } md={ md } lg={ lg }>
                {
                    type.includes('solid') ? (
                        <motion.input
                            type='submit'
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 1 }}
                            className={ classes.solidButton }
                            onClick={ action }
                            value={ title }
                        />
                    ) : (
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 1 }}
                            className={ classes.textButton }
                            onClick={ action }
                        >
                            { title }
                        </motion.div>
                    )
                }
            </Grid>
        </Grid>
    )
};

Button.defaultProps = {
    directionX: 'center',
    directionY: 'center',
    breakPoints: [10, 10, 10, 10],
    type: 'solid'
}

const useStyles = makeStyles({
    textButton: {
        color: '#fff',
		fontWeight: 600,
		letterSpacing: 1.5,
        textAlign: 'center',
		fontSize: 'clamp(.9rem, 4vw, 1rem)',
        minWidth: '5em',

        '&:hover': {
			cursor: 'pointer'
		}
    },
    solidButton: {
		background: '#977600',
		padding: '12px 25px',
		borderRadius: 32,
		textAlign: 'center',
		color: '#fff',
		fontWeight: 600,
		letterSpacing: 1.5,
		fontSize: 'clamp(.9rem, 4vw, 1rem)',
        width: '100%',
        minWidth: '5em',
        border: 'none',

		'&:hover': {
			cursor: 'pointer'
		}
	}
});